module.exports = __webpack_public_path__ + "graph.4a88fa60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatbotmakers/graph.png
// module id = 929
// module chunks = 0